"use client";

import { Dashboard } from "@/features/dashboard/components/layouts/Dashboard";
import { useAuthenticated } from "@gettactic/hooks";
import { DashboardStateProvider } from "@/features/dashboard/DashboardStateContext";
import { useState } from "react";
import { useInstallTelemetry } from "@/lib/hooks/useInstallTelemetry";
import { dashboardStateFallbackValues } from "@/features/dashboard/DashboardStateContext";
import { useBreakpoint } from "@gettactic/helpers/src/hooks/useBreakpoint";
import { MobileDashboard } from "@/features/dashboard/components/MobileDashboard";
import { useLocalStorageHandler } from "@gettactic/helpers/src/storage/useLocalStorageHandler";
import { DASHBOARD_SELECTED_OFFICES_STORAGE_KEY } from "@gettactic/helpers/src/resources/defines";

export const DashboardPage = () => {
  const {
    userContext: { authenticatedUser, currentOffice }
  } = useAuthenticated();

  const { isBreakpoint } = useBreakpoint();
  const isMd = isBreakpoint("md");

  const [selectedEvent, setSelectedEvent] = useState<any>(null);

  useInstallTelemetry();

  const orgId = authenticatedUser.organization?.id ?? "";
  const localStorage = useLocalStorageHandler(orgId);
  const savedOffices = localStorage.get<string[]>(
    DASHBOARD_SELECTED_OFFICES_STORAGE_KEY,
    []
  );

  const hideWeekends =
    authenticatedUser.organization?.features?.includes("hide.weekends") ??
    false;

  const initialOffices =
    savedOffices.length > 0
      ? savedOffices
      : currentOffice?.id
        ? [currentOffice.id]
        : [];

  return (
    <DashboardStateProvider
      hideWeekends={hideWeekends}
      organizationId={orgId}
      defaultFilters={{
        ...dashboardStateFallbackValues,
        offices: initialOffices
      }}
      selectedEvent={selectedEvent}
      setSelectedEvent={setSelectedEvent}
    >
      {isMd ? <Dashboard /> : <MobileDashboard />}
    </DashboardStateProvider>
  );
};
